export const iframeSrcFetch = (url: string): string => {
  const regExp = /src\s*=\s*"(.+?)"/;
  const match = url.match(regExp);
  return match ? match[1] : "";
};
